// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var Gauge = React.forwardRef(function Gauge(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Gauge" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.12359 20H19.8772C21.2073 18.3188 22 16.2008 22 13.9C22 8.43274 17.5225 4 12 4C6.47667 4 2 8.43274 2 13.9C2 16.2008 2.79341 18.3188 4.12359 20ZM12.3209 15.7791C11.8538 16.3366 11.0258 16.4096 10.4694 15.9418C9.91296 15.474 9.84111 14.6414 10.3081 14.0839C10.3686 14.0109 16.3297 8.25 16.3297 8.25L17 8.81537C17 8.81537 12.7222 15.2999 12.3209 15.7791Z", fill: "currentColor" }))));
});
Gauge.displayName = 'Gauge';
export default Gauge;
//# sourceMappingURL=Gauge.js.map